// src/WebPage.tsx
import React, { useEffect } from 'react';
import './WebPage.scss';
import { useNavigate } from 'react-router-dom';
import Menu from './components/Menu/Menu';
import WhoWeAre from './components/WhoWeAre/WhoWeAre';
import HeaderLanding from './components/HeaderLanding/HeaderLanding';
import WhyUs from './components/WhyUs/WhyUs';
import TabletSimulator from './components/TabletSimulator/TabletSimulator';
import Features from './components/Features/Features';
import CaseStudy from './components/CaseStudy/CaseStudy';
import Whatsapp from './components/Whatsapp/Whatsapp';
import Pricing from './components/Pricing/Pricing';

const WebPage: React.FC = () => {
  const [showModal, setShowModal] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      navigate('/App');
    }
    const contactFormSubmitted = localStorage.getItem('contactFormSubmitted');
    if (contactFormSubmitted) {
      setShowModal(false);
    } else {
      setTimeout(() => {
        setShowModal(true);
      }, 1500);
    }
  }, [navigate]);

  return (
    <div className="wp">
      <Menu />

      <main className="wp__main">
        <section id="header">
          <HeaderLanding />
        </section>

        <section id="who-we-are">
          <WhoWeAre />
        </section>

        <section id="features">
          <WhyUs />
        </section>

        <section>
          <TabletSimulator />
          <Features />
        </section>

        <section id="casestudy">
          <CaseStudy />
        </section>

        <section id="pricing">
          <Pricing />
        </section>
      </main>

      <footer className="wp__footer">
        <div className="wp__footer-inner">
          <div className="wp__footer-brand">
            <img
              src={`${process.env.PUBLIC_URL}/logos/logo-48.png`}
              alt="MedioPunto"
              className="wp__footer-logo"
            />
            <p className="wp__footer-tagline">
              La plataforma inteligente para restaurantes modernos.
            </p>
          </div>
          <div className="wp__footer-links">
            <a href="mailto:ventas@mediopunto.cl">ventas@mediopunto.cl</a>
            <a href="https://wa.me/56926974928" target="_blank" rel="noopener noreferrer">+569 2697 4928</a>
            <a href="https://mediopunto.ai" target="_blank" rel="noopener noreferrer">mediopunto.ai</a>
          </div>
          <div className="wp__footer-legal">
            <p>© {new Date().getFullYear()} MedioPunto — Krause Consulting SpA. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      <Whatsapp />
    </div>
  );
};

export default WebPage;
